import { BookingHour } from "../../data";
import { getHoursFromOpenCloseValues } from "./get_hours_from_open_close_values";

export function getMaxHoursFromBookingHours(bookingHours?: BookingHour[]) {
  let maxHoursIndex = 0;
  bookingHours?.reduce((maxHour, item, ind) => {
    const itemHour = getHoursFromOpenCloseValues(item.openAt, item.closedAt);

    if (itemHour > maxHour) {
      maxHoursIndex = ind;
      maxHour = itemHour;
    }

    return maxHour;
  }, 0);

  return bookingHours ? bookingHours[maxHoursIndex] : null;
}
